/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const WPActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditMerchantPage,
    openViewMerchantDialog,
    sendEmailMerchant,
    tabValues
  }
) => (
  <>
    <>
      <a
        title="Edit Merchant"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditMerchantPage(row.id,'wp',tabValues)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            title="Edit Merchant"
          />
        </span>
      </a>

      <a
        title="View Merchant"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
        onClick={() => openViewMerchantDialog(row.id,'wp',tabValues)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          
        <i className='fas fa-eye'></i>
        </span>
      </a>

      <a
        title="Send Email"
        className="btn btn-icon btn-light btn-hover-info btn-sm"
        //  style={{cursor: `not-allowed`}}
        onClick={() => sendEmailMerchant(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Map/Direction2.svg")}
           title="Send Email"
          //  title="Please do not send any mail from here as it is in testing"
          />
        </span>
      </a>
    </>
  </>
);
